/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_ExpandInputs */

const en_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand`)
};

const fr_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etendre`)
};

const de_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandieren`)
};

const it_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandere`)
};

const ru_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширять`)
};

const es_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir`)
};

const zh_cn2_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩张`)
};

const ja_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大する`)
};

const hi_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बढ़ाना`)
};

const pt_pt2_shortcut_keys_name_expand = /** @type {(inputs: Shortcut_Keys_Name_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir`)
};

/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Shortcut_Keys_Name_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_expand = /** @type {((inputs?: Shortcut_Keys_Name_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_expand(inputs)
	if (locale === "de") return de_shortcut_keys_name_expand(inputs)
	if (locale === "it") return it_shortcut_keys_name_expand(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_expand(inputs)
	if (locale === "es") return es_shortcut_keys_name_expand(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_expand(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_expand(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_expand(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_expand(inputs)
	return en_shortcut_keys_name_expand(inputs)
});